module.exports = __webpack_public_path__ + "img/banner1.f89e40a6.png";